// What a site link into the app carries (the site's first touch and the page the link was on); the backend's
// SignupAttribution has exactly these fields.
export const SIGNUP_ATTRIBUTION_FIELDS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
  'referrer', 'landing_path', 'gclid', 'gbraid', 'wbraid', 'cta_path',
];

const STORE_KEY = 'cc_signup_attribution';

// First touch wins: a visitor who comes back later through another link keeps the visit that brought them first.
export function captureSignupAttribution() {
  const url = new URL(window.location.href);
  const carried = {};
  SIGNUP_ATTRIBUTION_FIELDS.forEach((field) => {
    const value = url.searchParams.get(field);
    if (value) carried[field] = value;
    url.searchParams.delete(field);
  });
  if (Object.keys(carried).length === 0) return;
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  try {
    if (!localStorage.getItem(STORE_KEY)) localStorage.setItem(STORE_KEY, JSON.stringify(carried));
  } catch (e) {
    // Storage blocked (private mode): the sign-up simply goes without a source.
  }
}

export function signupAttribution() {
  try {
    const stored = localStorage.getItem(STORE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
}
